import * as React from 'react';

export default function ArrowUpCircle({ className, viewBox }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox={viewBox || '0 0 24 24'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0004 21.5984C17.3023 21.5984 21.6004 17.3004 21.6004 11.9984C21.6004 6.6965 17.3023 2.39844 12.0004 2.39844C6.69846 2.39844 2.40039 6.6965 2.40039 11.9984C2.40039 17.3004 6.69846 21.5984 12.0004 21.5984ZM16.4489 11.1499L12.8489 7.54991C12.3803 7.08128 11.6205 7.08128 11.1519 7.54991L7.55186 11.1499C7.08323 11.6185 7.08323 12.3783 7.55186 12.847C8.02049 13.3156 8.78029 13.3156 9.24892 12.847L10.8004 11.2955L10.8004 15.5984C10.8004 16.2612 11.3376 16.7984 12.0004 16.7984C12.6631 16.7984 13.2004 16.2612 13.2004 15.5984V11.2955L14.7519 12.847C15.2205 13.3156 15.9803 13.3156 16.4489 12.847C16.9175 12.3783 16.9175 11.6185 16.4489 11.1499Z"
        fill="currentColor"
      />
    </svg>
  );
}
